import {useEffect} from 'react'
import {useConversationEvents} from './ConversationStreamProvider'
import {baseApi} from '@apis/base.ts'
import {aiCoreAPI} from '@apis/aiCoreAPI'
import {edgeApi} from '@apis/edgeAPI'
import {infrastructureTenantsApi} from '@apis/infrastructureTenants'
import {useDispatch} from 'react-redux'

type AnyTag = {type: string; id: string}

type RtkTag = {type: string; id?: string}

/** invalidate both {type} and {type,id} so it works with or without LIST */
const toRtkTagsBoth = (tags: ReadonlyArray<AnyTag>): ReadonlyArray<RtkTag> => {
  const out: RtkTag[] = []
  const seen = new Set<string>()

  for (const t of tags) {
    // 1) tag without id (matches providesTags: ['Line'])
    const k1 = `${t.type}|`
    if (!seen.has(k1)) {
      out.push({type: t.type})
      seen.add(k1)
    }

    // 2) tag with id (matches providesTags: [{type:'Line', id:'LIST'}])
    if (t.id) {
      const k2 = `${t.type}|${t.id}`
      if (!seen.has(k2)) {
        out.push({type: t.type, id: t.id})
        seen.add(k2)
      }
    }
  }

  return out
}

export default function CacheInvalidationListener(): null {
  const {subscribe} = useConversationEvents()
  const dispatch = useDispatch()

  useEffect((): (() => void) => {
    return subscribe({
      onCacheInvalidate: (payload): void => {
        const tags = toRtkTagsBoth(payload.tags)

        if (payload.api === 'core') {
          dispatch(baseApi.util.invalidateTags(tags as never))
          return
        }

        if (payload.api === 'aicore') {
          dispatch(aiCoreAPI.util.invalidateTags(tags as never))
          return
        }
        if (payload.api === 'edge') {
          dispatch(edgeApi.util.invalidateTags(tags as never))
          return
        }
        if (payload.api === 'organizations') {
          dispatch(infrastructureTenantsApi.util.invalidateTags(tags as never))
          return
        }
      },
    })
  }, [dispatch, subscribe])

  return null
}
